import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function invoiceReducer(state = initialState.invoice, action) {
  switch (action.type) {
    case types.LOAD_INVOICE_SUCCESS:
      return action.invoice;
    case types.RESET_INVOICE_SUCCESS:
      return initialState.invoice;
    default:
      return state;
  }
}
